export enum ApproveAndContinueModes {
  SSO_MAIN = 'SSO_MAIN',
  SSO_OTHER_ACCOUNT_LOGGED_IN = 'SSO_OTHER_ACCOUNT_LOGGED_IN',
  SSO_MISSING_AUTH_SETTINGS = 'SSO_MISSING_AUTH_SETTINGS',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORGOT_EMAIL = 'FORGOT_EMAIL',
}
